/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import DailyClosingEvent from '../../event/DailyClosingEvent'
import { DailyClosingDetailState } from '../state/DailyClosingDetailState'

class DailyClosingDetailsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of(new DailyClosingDetailState())
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case DailyClosingEvent.fetchOne:
        const detail = payload.daily_closing_details.map(detail => new DailyClosingDetailState(detail))
        return List(detail)

      case DailyClosingEvent.addDetail:
        return state.push(new DailyClosingDetailState())

      case DailyClosingEvent.onEditDetail:
        const details = state.setIn([payload.index, payload.name], payload.value)
        return List(details)

      case DailyClosingEvent.onDeleteDetail:
        return state.remove(payload.index)

      case DailyClosingEvent.initialize:
      case DailyClosingEvent.onClear:
        return state.clear()

      default:
        return state
    }
  }
}

export default new DailyClosingDetailsStore()
